import { render, staticRenderFns } from "./ConfirmEezee.vue?vue&type=template&id=97972024&scoped=true&"
import script from "./ConfirmEezee.vue?vue&type=script&lang=js&"
export * from "./ConfirmEezee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97972024",
  null
  
)

export default component.exports